import styled from 'styled-components';

// Inline notices for the Bulk Upload v2 steps (errors, "Finding where each
// question starts…", pinned-elsewhere and loading states).

export const Notice = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  padding: 10px 14px;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  line-height: 20px;
  color: var(--text-primary, #1e252a);
  background: ${({ $tone }) =>
    $tone === 'bad'
      ? 'var(--error-red-light, #fdecea)'
      : 'var(--light-mode-purple-light, #f3e8fd)'};
`;

export const NoticeButton = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: var(--light-mode-purple, #7200e0);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  padding: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  text-align: center;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: var(--text-secondary, #6b7280);
`;
